import { gql } from "apollo-angular";
import { CBF } from "./content-block";
import { DIF } from "./disclaimer-item"

export const  MCF = gql`
  fragment MCF on MultiColumn {
    sys {
      id
    }
    isPzd
    title
    header
    headerAlignment
    headerTag
    hTagId
    backgroundColor {
      color
    }
    columnAlignment
    columnType
    iconType
    content
    columnWidth
    columnsCollection (limit: 15) {
        items {
          faIcon
          imageAlignment
          image {
            url
            description
          }
          video {
            url
            description
          }
          videoYouTubeLink
          mediaCaptionHeading
          mediaCaptionContent
          ... CBF  
      }
  }
  disclaimer {
    ... DIF
  }
}
${CBF}
${DIF}`;
